import { UseBgColorType } from './useBgColor'

export interface GygBtnColorType extends UseBgColorType {
  [key: string]: {
    color?: string
    backgroundColor: string
    hoverColor?: string
    reloadColor?: string
  }
}

const UseBtnColor = () => {
  return {
    primaryBtn: {
      backgroundColor: '#FFD204',
      hoverColor: '#EDBF00'
    },
    secondaryBtn: {
      backgroundColor: '#FFFFFF',
      hoverColor: '#FFFCEB',
      reloadColor: '#FBEFC7'
    },
    tertiaryBtn: {
      backgroundColor: '#E0E0E0',
      hoverColor: '#ACACAC'
    },
    errorBtn: {
      backgroundColor: '#ED4337',
      hoverColor: '#C10D00'
    },
    successBtn: {
      backgroundColor: '#14ae5c',
      hoverColor: '#029d4b'
    },
    linkBtn: {
      backgroundColor: '#FFFFFF',
      hoverColor: '#F0F0F0',
      reloadColor: '#E0E0E0'
    }
  }
}

export default UseBtnColor
